import { cn } from '@/lib/utils';
import { LiveCommentsSizePreset, SIZE_CYCLE } from './live-comments-panel-layout';

type LiveCommentsSizePickerProps = {
  size: LiveCommentsSizePreset;
  onChange: (size: LiveCommentsSizePreset) => void;
  compact?: boolean;
};

export function LiveCommentsSizePicker({
  size,
  onChange,
  compact = false,
}: LiveCommentsSizePickerProps) {
  return (
    <div
      className={cn(
        'flex shrink-0 overflow-hidden rounded-md border border-gray-300 bg-white',
        compact ? 'h-6' : 'h-7 sm:h-8',
      )}
      role="group"
      aria-label="Window size"
    >
      {SIZE_CYCLE.map((option) => {
        const active = size === option;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={active}
            title={`Size ${option.toUpperCase()}`}
            onClick={() => onChange(option)}
            className={cn(
              'min-w-[1.65rem] px-1 font-semibold uppercase transition-colors',
              compact ? 'text-[9px]' : 'text-[10px] sm:text-[11px]',
              active
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-600 hover:bg-gray-50',
            )}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
